import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M18.32 0H3.77C1.73 0 0 1.73 0 3.77v9.94c0 2.03 1.73 3.77 3.77 3.77h4.29l-.34 2.83H6.61a.85.85 0 1 0 0 1.7h8.67a.85.85 0 1 0 0-1.7h-.98l-.35-2.83h4.29c2.03 0 3.77-1.73 3.77-3.68V3.77c0-2.03-1.69-3.77-3.68-3.77Zm-5.19 20.31H8.87l.34-2.83h3.57zm7.13-6.52c0 .97-.93 1.99-2.07 1.99H3.77c-1.1 0-2.07-.97-2.07-2.07V3.77c0-1.1.97-2.07 2.07-2.07h14.55c.97 0 1.99.97 1.95 2.07V13.8Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M17.14 6.74a.54.54 0 0 0-.32-.25l-5.55-2.8a.6.6 0 0 0-.55 0L5.14 6.51a.55.55 0 0 0-.39.56c0 .23.13.43.35.54l2.4 1.21v2.77c0 .61.23 1.09.68 1.4.29.21 1.33.91 2.86.91 1.36 0 2.37-.58 2.91-.89l.11-.09c.43-.43.65-.88.65-1.33V8.71l1.3-.65v1.25c0 .35.27.62.62.62s.62-.27.62-.62V7.07c0-.11-.04-.21-.09-.31 0 0-.01-.02-.02-.02m-6.1 5.93c-1.11 0-1.92-.5-2.15-.66-.08-.06-.19-.16-.19-.41V9.43l2.02 1.02c.09.04.18.07.27.07s.19-.02.27-.07l2.19-1.11v2.25c0 .09-.07.26-.21.42-.42.23-1.25.66-2.21.66ZM11 9.21 8.41 7.92s-.09-.05-.14-.07l-1.55-.77 4.27-2.17 4.27 2.17-4.27 2.14Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }